
import { useValidationContext } from "@features/mx/validations/context";
import NewReadingList from "./NewReadingList";
import ValidationDetailsView from "../../shared/ValidationDetailsView";
function NewReadingLanding() {
  const { viewMode, readingId, validatorId } = useValidationContext();
  return viewMode === "detail" ? (
    <ValidationDetailsView readingId={readingId} />
  ) : (
    <NewReadingList />
  );
}

export default NewReadingLanding;
